import React from "react";

function MainSection() {
  return (
    <section id="home" className="main-section">
      <div className="main-content">
        <h1> Welcome to Our Industry Solutions </h1>{" "}
        <h2> TEAM PROCESS AND MECHANICAL DESIGN(TPMD) </h2>{" "}
        <p> Delivering excellence in engineering and industrial solutions </p>{" "}
      </div>{" "}
    </section>
  );
}

export default MainSection;
